import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { MeResponse } from '@dtable/shared-types';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  accessTokenExpiresAt: string | null;
  me: MeResponse | null;
  setTokens: (t: { accessToken: string; refreshToken: string; accessTokenExpiresAt: string }) => void;
  setMe: (me: MeResponse | null) => void;
  clear: () => void;
}

/**
 * Auth is persisted so a full page reload doesn't kick the user back to login.
 * Tokens are stored in localStorage — acceptable for an internal enterprise
 * tool but we should revisit if we ever expose HRMS to end customers.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      accessTokenExpiresAt: null,
      me: null,
      setTokens: (t) =>
        set({
          accessToken: t.accessToken,
          refreshToken: t.refreshToken,
          accessTokenExpiresAt: t.accessTokenExpiresAt,
        }),
      setMe: (me) => set({ me }),
      clear: () =>
        set({
          accessToken: null,
          refreshToken: null,
          accessTokenExpiresAt: null,
          me: null,
        }),
    }),
    {
      name: 'dtable-hrms-auth',
      partialize: (s) => ({
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
        accessTokenExpiresAt: s.accessTokenExpiresAt,
      }),
    },
  ),
);
